import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import ConnectStorage from "@ext/catalog/actions/ConnectStorage";
import t from "@ext/localization/locale/translate";
import { GlassToolbar, GlassToolbarButton, GlassToolbarIcon, GlassToolbarText } from "@ui-kit/GlassToolbar";

const ConnectStorageToolbar = () => {
	const { url, enabled } = PageDataContextService.value.conf.enterpriseCloud;

	return (
		<GlassToolbar className="w-fit" variant="single">
			<ConnectStorage
				trigger={(isLoading) => (
					<GlassToolbarButton data-qa="qa-connect-storage" data-testid="connect-storage-trigger" focusable>
						{isLoading ? (
							<GlassToolbarIcon
								className="animate-spin motion-reduce:animate-none"
								icon="loader-circle"
							/>
						) : (
							<GlassToolbarIcon icon="cloud-off" />
						)}
						<GlassToolbarText className="text-xs font-medium">
							{url && enabled ? t("publish-catalog") : t("connect-storage")}
						</GlassToolbarText>
					</GlassToolbarButton>
				)}
			/>
		</GlassToolbar>
	);
};

export default ConnectStorageToolbar;
